import React from "react";
import cx from "classnames";
import { PrefixContainer, StyledInputContainer } from "./input.styles";
import { InputLabel } from "../inputLabel";
import { InputWrapper } from "../inputWrapper";
import { CustomisableStyledInput } from "./customisableStyledInput";
import { ValidationMessage } from "../validationMessage";

export const Input = React.forwardRef((props, ref) => {
  const {
    title, placeholder, onChange, onBlur, value, name, type,
    maxLength, inputMode, prefix, toolTipText, className, errorMessage,
    inputRender, disabled, showErrorMessage
  } = props;

  const hasError = !!errorMessage;
  const hasPrefix = !!prefix;

  return (
    <InputWrapper className={cx(className, {disabled})} name={name}>
      <InputLabel name={name} toolTipText={toolTipText} title={title} />
      <StyledInputContainer className={cx({ "has-error": hasError, valid: !hasError && !!value })}>
        {hasPrefix && <PrefixContainer>{prefix({ hasError })}</PrefixContainer>}
        <CustomisableStyledInput
          inputRender={inputRender}
          disabled={disabled}
          ref={ref}
          onChange={onChange}
          value={value || ""}
          name={name}
          type={type}
          onBlur={onBlur}
          placeholder={placeholder}
          maxLength={maxLength}
          inputMode={inputMode}
        />
      </StyledInputContainer>
      {showErrorMessage && <ValidationMessage errorMessage={errorMessage} />}
    </InputWrapper>
  )
});